import * as React from 'react';
import { Slot } from 'radix-ui';

import { cn } from '@shared/utils/cn';

// Breadcrumbs Minimal : body2, écart 16px, séparateur en point
const Breadcrumb = (props: React.ComponentProps<'nav'>) => (
  <nav aria-label="Fil d'Ariane" data-slot="breadcrumb" {...props} />
);

const BreadcrumbList = ({ className, ...props }: React.ComponentProps<'ol'>) => (
  <ol
    className={cn('flex flex-wrap items-center gap-x-4 gap-y-1 text-sm break-words', className)}
    data-slot="breadcrumb-list"
    {...props}
  />
);

const BreadcrumbItem = ({ className, ...props }: React.ComponentProps<'li'>) => (
  <li className={cn('inline-flex items-center gap-4', className)} data-slot="breadcrumb-item" {...props} />
);

const BreadcrumbLink = ({ asChild, className, ...props }: React.ComponentProps<'a'> & { asChild?: boolean }) => {
  const Comp = asChild ? Slot.Root : 'a';

  return (
    <Comp
      className={cn('text-foreground transition-colors hover:underline', className)}
      data-slot="breadcrumb-link"
      {...props}
    />
  );
};

const BreadcrumbPage = ({ className, ...props }: React.ComponentProps<'span'>) => (
  <span
    aria-current="page"
    aria-disabled="true"
    className={cn('text-muted-foreground', className)}
    data-slot="breadcrumb-page"
    role="link"
    {...props}
  />
);

const BreadcrumbSeparator = ({ className, ...props }: React.ComponentProps<'li'>) => (
  <li
    aria-hidden="true"
    className={cn('size-1 rounded-full bg-muted-foreground/48', className)}
    data-slot="breadcrumb-separator"
    role="presentation"
    {...props}
  />
);

export { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator };
